import { Base } from '@studiometa/js-toolkit';
import { debounce } from '@studiometa/js-toolkit/utils';

/**
 * @typedef {InputText & {
 *   $el: HTMLInputElement
 * }} InputTextInterface
 */
/**
 * InputText component
 */
export default class InputText extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'InputText',
    emits: ['changing'],
  };

  /**
   * mounted
   * @this {InputTextInterface & Base}
   */
  mounted() {
    this.debounce = debounce(() => {
      const { value } = this.$el;
      if (value > 0 && value <= 2) {
        return;
      }
      this.$emit('changing', value);
    }, 500);
  }

  /**
   * onKeypress
   * @this {InputTextInterface}
   */
  onInput() {
    this.debounce();
  }
}
